import { useState } from 'react';
import { outreachFormRespondUrl, outreachProductName } from '@aegislab/shared';
import { OutreachPreviewOverlay } from '@/entities/outreach-draft';
import { useOutreachDraft, useSignedImageUrl } from '@/entities/outreach-draft';
import { useScenarioDetail } from '@/entities/scenario';
import { SendConfirmRecipientView } from './SendConfirmRecipientView';
import { asideRoot } from './SendConfirmPanel.css';

export interface SendConfirmRecipientAsideProps {
  scenarioId: string;
  country: string;
}

/**
 * 발송 확인의 곁 칸 — 단계 상자 **밖**에 형제로 선다(승인 시안 ConfirmAfter 개선안, 2026-09-29).
 *
 * 왜 별도 컨테이너인가: 상자 안팎은 DOM 부모가 다르라 한 컴포넌트가 둘 다 그릴 수 없다. 덮개가
 * `composer.aside` 슬롯을 열고 페이지 층이 이것을 거기 꽂는다.
 *
 * **초안·시나리오 호출은 안 는다.** `SendConfirmContainer` 와 같은 쿼리를 부르므로 캐시가 같은
 * 응답을 준다. 대표 이미지의 서명 주소도 작성기와 같은 키라, 작성기가 방금 풀어 둔 것이 있으면
 * 그대로 받고 없을 때만 한 번 요청한다.
 */
export function SendConfirmRecipientAside({ scenarioId, country }: SendConfirmRecipientAsideProps) {
  const [isPreviewOpen, setPreviewOpen] = useState(false);
  const draft = useOutreachDraft(scenarioId, country);
  const scenario = useScenarioDetail(scenarioId);

  const content = draft.data?.content;
  const imageUrl = useSignedImageUrl(content?.image?.assetPath);
  if (!content) return null;

  const formUrl = outreachFormRespondUrl(scenario.data?.outreachFormUrl ?? '');
  const productName = outreachProductName(scenario.data?.products ?? []);

  return (
    // 전체 미리보기 오버레이가 이 칸 안에만 덮이도록 기준 상자를 만든다.
    <div className={asideRoot}>
      <SendConfirmRecipientView
        content={content}
        formUrl={formUrl}
        imageUrl={imageUrl}
        productName={productName}
        onOpenPreview={() => setPreviewOpen(true)}
      />
      {isPreviewOpen && (
        <OutreachPreviewOverlay
          content={content}
          formUrl={formUrl}
          imageUrl={imageUrl}
          productName={productName}
          onClose={() => setPreviewOpen(false)}
        />
      )}
    </div>
  );
}
